import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/caution_blue.png'
import _imports_1 from '@/assets/image/icon/caution_black.png'


const _withScopeId = n => (_pushScopeId("data-v-0c2cd82a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter switch" }
const _hoisted_2 = { class: "desc" }
const _hoisted_3 = { class: "desc" }
const _hoisted_4 = {
  key: 1,
  class: "text-rt",
  style: {"flex":"1"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"line-height":"20px"} }
const _hoisted_7 = { style: {"line-height":"20px"} }
const _hoisted_8 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_9 = { class: "rel" }
const _hoisted_10 = { style: {"width":"280px"} }
const _hoisted_11 = { class: "el-dropdown-link flex-ter" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { style: {"min-width":"150px","padding":"10px"} }
const _hoisted_14 = { class: "flex-ter" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"21px","margin-right":"4px"},
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_CN.png",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_16 = { class: "flex-ter" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"21px","margin-right":"4px"},
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_JP.png",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "abs fee-pdf flex-ter",
  style: {"top":"36px","right":"0","line-height":"18px","height":"auto"}
}
const _hoisted_19 = { style: {"white-space":"nowrap"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_21 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_22 = { class: "express-addition" }
const _hoisted_23 = { class: "tool-text" }
const _hoisted_24 = { class: "flex-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-bianji" }, null, -1))
const _hoisted_26 = { class: "edit-text" }
const _hoisted_27 = {
  key: 0,
  class: "tiktok-warning"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "warning-icon",
  src: "https://static-s.theckb.com/BusinessMarket/Client/api-warning.png",
  alt: ""
}, null, -1))
const _hoisted_29 = { style: {"font-weight":"500","flex":"1"} }
const _hoisted_30 = { style: {"width":"90%","color":"#fff"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","cursor":"pointer"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "caution-icon",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"text-decoration":"underline","margin-right":"10px","color":"#0586FE"} }, " 出荷期限とリスクについて ")
], -1))
const _hoisted_32 = { style: {"padding":"6px","max-width":"480px"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","font-weight":"500","display":"flex","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"height":"16px","margin-right":"4px"},
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 出荷期限とリスクについて： ")
], -1))
const _hoisted_34 = { style: {"color":"rgba(0, 0, 0, 0.65)","margin-top":"6px"} }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" TikTokでは、ご注文から3営業日以内の出荷が必須です。 遅延によりペナルティやクレームの対象になる可能性があります。")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 納品後でもシステム・物流・政策などの影響で遅延が発生する可能性があります。")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 当社ではこれらによる責任は負いかねますので、あらかじめご了承ください。")
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, reactive, onMounted, computed, watch, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import { HomeFilled, ArrowDownBold } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import useRules, { useMust } from '@/util/useRules'
import { getCustomerShopShipListApi, getShopLogistics, RecommendedLogistics } from '@/apis/setup'
import { getCustomerShop } from '@/apis/order'
import { useUser, expressCostPdf, isD2C, useSite2Code, isJA, isKO, isEN, useSite, getWarehouseCode, getWarehouseByCountry } from '@/store'
import setName from '@/util/useArea'
import { getDeli } from '@/util/calcAdt'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import UploadFileBtn from './UploadFileBtn.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import SortSelect from '@/components/common/SortSelect.vue'
import { getAreaList, getTotalCountryList, getAddressCodeName } from '@/util/useCountry'
import { getCountryListApi, getCountryExpressListApi, throughCountryGetExpressApi } from '@/apis/user'
import { useStore } from 'vuex'
import { openKakooAddr } from '@/plugins/addr'
import ExpressSelect from '@/components/ExpressSelect/index.vue'
import { getLastTiktokWare, setLastTiktokWare, sourceCountryRef, useSourceCountry } from '../country'
import { COUNTRY } from '@/global'
import AddAddressBtn from './AddAddress/Btn.vue'
import QuestionMark from '@/components/IconPark/QuestionMark.vue'
import { jpWareInfo, ShopType } from '@/common/const'
import { request } from '@/config/request/interceptors'
import { WarehousePojo } from '@/service/customer'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: ['mode', 'modes', 'isCanUseOnTheWayStock', 'checkList', 'isChoice', 'showBtn'],
  emits: ['updateDeliver', 'update:mode', 'success'],
  setup(__props, { emit }) {

const props = __props


const formRef = ref()
const store = useStore()
const deliverData = computed(() => store.state.bussiness.deliverData?.[sourceCountryRef.value])
const isTikTokShop2C = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C())
// 系统店铺仓库
const wareInfo = ref<WarehousePojo>({})
// 用户选择仓库
const selectedWareInfo = ref<WarehousePojo>({})
const [country, changeCountryQuery] = useSourceCountry()
const model: any = reactive(deliverData.value ?? {
  receiveName: '',
  receiveTel: '',
  countryCode: '',
  country: '',
  countryJp: '',
  province: '',
  city: '',
  district: '',
  address: '',
  postalCode: '',
  intShipConfigId: '',
  intForwarderConfigId: '',
  deliveryAdditionalList: [],
  email: useUser()?.customerEmail,
  clearanceCode: ''
})

const skuList = ref([])
watch(() => props.checkList, () => {
  let list: any = []
  props.checkList.forEach((item: any) => {
    if (item.productType === 3) {
      list = [...list, ...item.combinationProductItemList.map((i) => {
        return {
          // 必须算真实数量，而不是减去库存的数量
          num: i.valueQuantity,
          productSku: i.productSku,
          productType: i.productType
        }
      })]
      return
    }
    list.push({
      // 必须算真实数量，而不是减去库存的数量
      num: item.orderQuantity,
      productSku: item.productSku,
      productType: item.productType
    })
  })
  skuList.value = list
}, {
  deep: true,
  immediate: true
})
watch(() => props.isChoice, () => {
  if (props.isChoice) {
    if (model.countryCode !== 'JP') {
      ElMessage.warning(t('choice商品目前仅支持日本，已为你自动切换'))
      const country: any = countryList.value?.find((v: any) => v.code === 'JP')
      if (country) {
        model.country = country.intAreaId
        changeCountry(country)
      } else {
        model.country = ''
      }
    }
  }
})
watch(model, () => {
  const deliverData = {
    ...store.state.bussiness.deliverData,
    [sourceCountryRef.value]: model
  }
  store.commit('bussiness/deliverData', deliverData)
}, {
  deep: true
})

const route = useRoute()
/**
 * 1.监听仓库店铺，购物车国家变化,满足 tiktok 店铺，中国，日本仓库，默认切换至日本收货地址且禁用
 */
watch(() => selectedWareInfo.value, () => {
  if (selectedWareInfo.value.warehouseCountry === COUNTRY.CN) {
    setLastTiktokWare(COUNTRY.CN)
  }
  if (selectedWareInfo.value.warehouseCountry === jpWareInfo.warehouseCountry && country.value === COUNTRY.CN) {
    const country: any = countryList.value?.find((v: any) => v.code === 'JP')
    setLastTiktokWare(COUNTRY.JP)
    if (country) {
      if (model.country !== country.intAreaId) {
        model.country = country.intAreaId
        changeCountry(country)
        model.address = ''
        model.postalCode = ''
        model.province = ''
        model.receiveName = ''
        model.receiveTel = ''
      }
    } else {
      model.country = ''
    }
  }
}, {
  deep: true
})

const phoneCode = ref('-')
const countryList = ref([])

// watch(() => model.deliveryAdditionalList, () => {
//   console.log(model.deliveryAdditionalList, 'model.deliveryAdditionalList')
// }, { immediate: true })

const init = async () => {
  model.email = useUser()?.customerEmail
  if (!model.deliveryAdditionalList?.length) {
    getDeli(getWarehouseByCountry(sourceCountryRef.value)).then((data: any) => {
      model.deliveryAdditionalList = data
    })
  }
  const countryResult = await getCountryListApi({ warehouseCode: getWarehouseByCountry(sourceCountryRef.value) })
  const totalCountry: any = !isKO() ? await getTotalCountryList() : [{
    intAreaId: '2064',
    pid: '1976',
    level: '2',
    name: '韩国',
    nameEn: 'Republic of Korea',
    namePinyin: 'hanguo',
    nameJa: '大韓民国',
    nameKr: '대한민국',
    code: 'KR',
    areaNum: '82',
    children: null
  }]
  const list: any = []
  let isMatchSiteCountry = false
  let countryItem: any
  // 筛选配置的国家信息
  // 默认为当前站点下的国家
  countryResult.data.forEach((i: any) => {
    if (i.countryCode === useSite2Code()) {
      isMatchSiteCountry = true
    }
    countryItem = totalCountry.find((k: any) => k.code === i.countryCode)
    countryItem && list.push(countryItem)
  })
  countryList.value = list
  if (model.country) {
    // 保存原先的省市
    const { province, city } = model
    const countryItem = totalCountry.find((k: any) => k.intAreaId === model.country)
    // 重置后重新赋值
    changeCountry(countryItem).then(() => {
      model.province = province
      changeProvince({ intAreaId: province })
      model.city = city
    })
  } else if (isMatchSiteCountry) {
    const countryItem = totalCountry.find((k: any) => k.code === useSite2Code())
    model.country = countryItem.intAreaId
    changeCountry(countryItem)
  } else {
    model.country = ''
  }
}
init()

const expresses: any = ref([])

const provinces: any = ref([])
const cities: any = ref([])

// area.then((data) => {
//   provinces.value = data
// })

const rules = computed(() => {
  const JPRule = {
    country: useMust(t('国家不能为空')),
    receiveName: useRules({ message: t('收件人不能为空'), key: 'deliver' }),
    receiveTel: useRules({ message: t('联系电话不能为空'), key: 'phone' }),
    province: useMust(t('都道府县不能为空'), 'change'),
    city: countryCode.value === 'US' ? useMust(t('市不能为空'), 'change') : undefined,
    address: useRules({ message: t('详细地址不能为空'), key: model.country === '2115' ? 'address40' : 'address' }),
    postalCode: useRules({ message: t('邮编不能为空'), key: model.country && model.country === '2279' ? 'postal' : 'postalCode' }),
    intShipConfigId: useMust(t('物流公司不能为空'), 'change'),
    clearanceCode: useRules({ message: t('通关码不能为空'), key: 'clearanceCode' })
  }
  clearFomValidate()

  console.log(JPRule, 'JPRule')

  return JPRule
})
// 下单后重置
const clear = () => {
  Object.keys(model).forEach((k) => {
    model[k] = ''
  })
  init()
  clearFomValidate()
}

const clearFomValidate = () => {
  setTimeout(() => {
    formRef.value && formRef.value.clearValidate(['province', 'city', 'intShipConfigId', 'receiveName', 'receiveTel', 'address', 'postalCode', 'clearanceCode'])
  })
}
const shipChange = (val: string) => {
  model.intForwarderConfigId = expresses.value.find(
    (v: any) => v.intShipConfigId === val
  )?.forwarder?.intForwarderConfigId
}
const getName = (code: any) => {
  if (isJA() && code === 'JP') {
    return 'nameJa'
  }
  if (isKO() && code === 'KR') {
    return 'nameKr'
  }
  return 'nameEn'
}
console.log(props.checkList, 'props.checkList')
const jumpExpressPrice = () => {
  console.log(props.checkList, 'props.checkList')
  if (!props.checkList?.length) {
    ElMessage.warning(t('请选择商品'))
    return
  }
  console.log(props.checkList, 'props.checkList')

  const countryCode = useSite2Code()
  const params = {
    membershipTemplateId: store.getters.user.membership?.membershipTemplateId,
    productParam: props.checkList.map((item: any) => {
      return {
        additionList: [],
        num: item.orderQuantity,
        productInfo: {
          productSellPrice: item.productSellPrice,
          productSkuImg: item.productSkuImg,
          productTitle: countryCode === 'JP' ? item.productTitleJp : item.productTitle
        },
        productPropertiesName: item.productPropertiesName,
        productAttribute: {
          width: item.width,
          height: item.height,
          length: item.length,
          weight: item.weight
        },
        productType: item.productType,
        productPriceLadderList: item.productPriceLadderList,
        productSellPrice: item.productSellPrice,
        productSku: item.productSku,
        combinationProductItemList: item.combinationProductItemList?.map((combine: any) => {
          return {
            unitNums: combine.buyQuantity,
            productAttribute: {
              width: combine.width,
              height: combine.height,
              length: combine.length,
              weight: combine.weight
            },
            productPropertiesName: item.productPropertiesName,
            productSellPrice: combine.productSellPrice,
            productSkuImg: combine.productSkuImg,
            productTitle: countryCode === 'JP' ? combine.productTitleJp : combine.productTitle
          }
        }) ?? []
      }
    }),
    shipParam: {
      countryCode: model.countryCode,
      intShipConfigId: model.intShipConfigId
    }
  }
  window.localStorage.setItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`, JSON.stringify(params))
  window.open('/oem/utility/InterLogistics?from=inshipping')
}
const shipParamChangeListner = (event: any) => {
  if (event.key === `Calculator_${isD2C() ? 1 : 2}_inshipping`) {
    const { shipParam } = JSON.parse(window.localStorage.getItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`) ?? '{}')
    console.log('接收：', shipParam)
    if (shipParam?.intShipConfigId) {
      model.intShipConfigId = shipParam?.intShipConfigId
    }
  }
}
const countryCode = ref('')

onMounted(() => {
  window.addEventListener('storage', shipParamChangeListner)
  emit('updateDeliver', () => {
    return new Promise((resolve) => {
      formRef.value.validate(async (valid: boolean) => {
        const addressInfo = await getAddressCodeName({
          area: model.province,
          city: model.city,
          countryCode: model.countryCode
        })
        countryCode.value = addressInfo.countryCode
        model.countryJp = addressInfo.countryItem?.[getName(addressInfo.countryCode)]
        model.provinceJp = addressInfo.areaItem?.[getName(addressInfo.countryCode)]
        model.cityJp = addressInfo.cityItem?.[getName(addressInfo.countryCode)]
        // setName(model, { province: 'provinceJp', city: 'cityJp' })
        // console.log(model)
        if (valid) {
          resolve([model, clear])
        } else {
          resolve(undefined)
        }
      })
    })
  })
})

onUnmounted(() => {
  window.removeEventListener('storage', shipParamChangeListner)
})

const showAdt = ref(false)

request.customer.customer.shopGet({}).then((res) => {
  console.log(res, 'getCustomerShop')
  if (res.success) {
    const warehouseList = res.data?.warehouseList ?? []
    // 表结构变了，换种形式获取仓库名称
    const ware = warehouseList.find((item) => item.warehouseCountry === (sourceCountryRef.value !== COUNTRY.KR ? COUNTRY.CN : COUNTRY.KR))!
    wareInfo.value = ware
    if (getLastTiktokWare() === COUNTRY.JP) {
      selectedWareInfo.value = jpWareInfo
    } else {
      selectedWareInfo.value = ware
    }
  }
})

const changeCountry = async (countryItem: any) => {
  countryCode.value = countryItem.code
  model.province = ''
  model.city = ''
  cities.value = []
  model.countryCode = countryItem.code
  model.countryJp = countryItem.code === 'JP' ? countryItem.nameJa : countryItem.nameEn
  phoneCode.value = '+' + countryItem.areaNum
  await getAreaList(countryItem).then((res: any) => {
    provinces.value = res
    if (!provinces.value || provinces.value.length === 0) {
      model.province = '-'
    }
  })
  throughCountryGetExpressApi({
    countryCode: countryItem.code,
    countryJpyName: countryItem.nameJa,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(sourceCountryRef.value)
  }).then((res: any) => {
    if (res.success) {
      expresses.value = res.data
    }
  })
    .then(async (res) => {
      // 先去店铺物流信息
      const { data: shopConfigExpress } = await getCustomerShopShipListApi({ warehouseCode: getWarehouseByCountry(sourceCountryRef.value) })
      const expressObj: any = {}
      shopConfigExpress.forEach((item: any) => {
        expressObj[item.countryCode] = item
      })
      if (expressObj[countryItem.code]) {
        // 先去店铺配置
        model.intShipConfigId = expressObj[countryItem.code].logisticsId
      } else {
        // 没有则取第一个物流
        model.intShipConfigId = (expresses.value?.length > 0 ? expresses.value[0].intShipConfigId : '')
      }
      // }
      shipChange(model.intShipConfigId)
      clearFomValidate()
    })
}

const changeProvince = (temp: any) => {
  model.city = ''
  cities.value = provinces.value.find((i: any) => i.intAreaId === temp.intAreaId)?.children
}

const getData = () => {
  return {
    skuList: skuList.value,
    countryCode: countryCode.value,
    systemSource: isD2C() ? 1 : 2
  }
}

const editAddress = async (address: any) => {
  const addressInfo = await getAddressCodeName({
    area: address.province,
    city: address.city,
    countryCode: address.countryCode
  })
  await changeCountry(addressInfo.countryItem)
  cities.value = addressInfo.cityList
  model.country = address.country
  model.receiveName = address.receiveName
  model.postalCode = address.postalCode
  model.province = address.province
  model.city = address.city
  model.address = address.address
  model.receiveTel = address.receiveTel
}
const edit = () => {
  if (props.isChoice) {
    ElMessage.warning(t('发货附加项只对代采商品生效，choice商品无法编辑发货附加项'))
    return
  }
  showAdt.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-mode rel", _unref(useSite)()])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modes, (v) => {
        return (_openBlock(), _createBlock(_component_el_button, {
          class: "flex-col-ter mr_20 mode-btn",
          type: "primary",
          key: v.label,
          plain: !(v.value === __props.mode),
          onClick: ($event: any) => (emit('update:mode', v.value))
        }, {
          default: _withCtx(() => [
            ([1].includes(v.value))
              ? (_openBlock(), _createBlock(SvgIcon, {
                  key: 0,
                  class: "deli-icon mr_5",
                  name: v.value ? 'zhifa' : 'zaiku'
                }, null, 8, ["name"]))
              : (_openBlock(), _createBlock(SvgIcon, {
                  key: 1,
                  class: "deli-icon mr_5 stock_icon",
                  name: "stock"
                })),
            _createElementVNode("span", _hoisted_2, _toDisplayString(v.label), 1)
          ]),
          _: 2
        }, 1032, ["plain", "onClick"]))
      }), 128)),
      (__props.showBtn && _unref(country) === 'CN')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "flex-col-ter mr_20 mode-btn",
            type: "primary",
            plain: !(2 === __props.mode),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:mode', 2)))
          }, {
            default: _withCtx(() => [
              _createVNode(SvgIcon, {
                class: "deli-icon mr_5 stock_icon",
                name: "stock"
              }),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('备货到日本')), 1)
            ]),
            _: 1
          }, 8, ["plain"]))
        : _createCommentVNode("", true),
      ([0, 1].includes(__props.mode))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_unref(sourceCountryRef) !== _unref(COUNTRY).KR && __props.mode === 1 && _unref(isJA)())
              ? (_openBlock(), _createBlock(AddAddressBtn, {
                  key: 0,
                  countryList: countryList.value,
                  onSubmit: editAddress
                }, null, 8, ["countryList"]))
              : _createCommentVNode("", true),
            (!(_unref(sourceCountryRef) == _unref(COUNTRY).JP && __props.mode == 1))
              ? (_openBlock(), _createBlock(UploadFileBtn, {
                  key: 1,
                  isCanUseOnTheWayStock: _ctx.$props.isCanUseOnTheWayStock,
                  mode: __props.mode,
                  onSuccess: _cache[1] || (_cache[1] = ($event: any) => (emit('success')))
                }, null, 8, ["isCanUseOnTheWayStock", "mode"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    ([0, 1].includes(__props.mode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            class: _normalizeClass([{ hidden: __props.mode === 0 }, "receive-form"]),
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              formRef.value = _value
            },
            model: _unref(model),
            rules: _unref(rules),
            inline: true,
            "label-width": 120
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "country",
                label: _unref(t)('国/地区'),
                "label-width": 90
              }, {
                default: _withCtx(() => [
                  _createVNode(SortSelect, {
                    value: _unref(model).country,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).country) = $event)),
                    onChange: changeCountry,
                    list: countryList.value,
                    type: "country",
                    rowKey: "intAreaId",
                    width: 270,
                    placeholder: _unref(t)(_unref(isJA)() ? '支持日文/英文搜索' : '支持韩文/英文搜索'),
                    disabled: __props.isChoice || (_unref(sourceCountryRef) !== _unref(COUNTRY).KR && selectedWareInfo.value.warehouseCountry === _unref(jpWareInfo).warehouseCountry)
                  }, null, 8, ["value", "list", "placeholder", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "receiveName",
                label: _unref(t)('收件人'),
                "label-width": 100,
                class: "lh-32"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    class: "receive-name",
                    modelValue: _unref(model).receiveName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).receiveName) = $event)),
                    maxlength: 20
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "receiveTel",
                label: _unref(t)('联系电话')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(model).receiveTel,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).receiveTel) = $event)),
                    class: "receive-tel",
                    maxlength: 20
                  }, {
                    prepend: _withCtx(() => [
                      _createTextVNode(_toDisplayString(phoneCode.value), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              (_unref(model).country === '2064')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_form_item, {
                      prop: "postalCode",
                      label: _unref(t)('邮编'),
                      "label-width": 90,
                      class: "lh-32"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          style: {"width":"170px","margin-right":"10px"},
                          modelValue: _unref(model).postalCode,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(model).postalCode) = $event)),
                          maxlength: 20,
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          style: {"width":"90px"},
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(openKakooAddr)(_unref(model), provinces.value)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('搜索地址')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      prop: "province",
                      "label-width": 100,
                      class: _normalizeClass([{ jp: _unref(model).country === '2279' }])
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(model).country === '2279' ? _unref(t)('都道府县') : _unref(t)('都道府県/州/地域')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(SortSelect, {
                          value: _unref(model).province,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(model).province) = $event)),
                          onChange: changeProvince,
                          list: provinces.value,
                          type: "province",
                          country: _unref(model).country,
                          rowKey: "intAreaId",
                          width: 280,
                          disabled: "",
                          "dont-select": true
                        }, null, 8, ["value", "list", "country"])
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_form_item, {
                      prop: "province",
                      "label-width": 90,
                      class: _normalizeClass([{ jp: _unref(model).country === '2279' }, 'province-form'])
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(model).country === '2279' ? _unref(t)('都道府县') : _unref(t)('都道府県/州/地域')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(SortSelect, {
                          value: _unref(model).province,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(model).province) = $event)),
                          onChange: changeProvince,
                          list: provinces.value,
                          type: "province",
                          country: _unref(model).country,
                          rowKey: "intAreaId",
                          width: 270,
                          placeholder: _unref(model).country === '2279' && _unref(isJA)() ? _unref(t)('支持日文搜索') : _unref(t)('支持英文搜索')
                        }, null, 8, ["value", "list", "country", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_el_form_item, {
                      prop: "city",
                      label: _unref(t)('市区町村'),
                      "label-width": 100,
                      class: "lh-32"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SortSelect, {
                          value: _unref(model).city,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(model).city) = $event)),
                          list: cities.value,
                          type: "city",
                          country: _unref(model).country,
                          rowKey: "intAreaId",
                          width: 280,
                          placeholder: _unref(model).country === '2279' && _unref(isJA)() ? _unref(t)('支持日文搜索') : _unref(t)('支持英文搜索')
                        }, null, 8, ["value", "list", "country", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      prop: "postalCode",
                      label: _unref(t)('邮编'),
                      "label-width": 120,
                      class: "lh-32"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          class: "receive-mailcode",
                          modelValue: _unref(model).postalCode,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(model).postalCode) = $event)),
                          maxlength: 20
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ], 64)),
              _createVNode(_component_el_form_item, {
                prop: "address",
                label: _unref(t)('详细地址'),
                "label-width": 90
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "texta",
                    class: "receive-address",
                    modelValue: _unref(model).address,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(model).address) = $event)),
                    maxlength: 100
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "intShipConfigId",
                style: _normalizeStyle([{"word-break":"break-word"}, { transform: _unref(isKO)() && 'translateY(-50px)' }])
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('选择物流公司')) + " ", 1),
                    (_unref(isJA)())
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          effect: "light",
                          placement: "top",
                          "popper-class": "tool-tip-no-border"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('此设置只针对代采商品生效')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(QuestionMark, {
                              size: 14,
                              color: "#333",
                              class: "cursor-pt",
                              style: {"vertical-align":"text-top","margin-top":"3px"}
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(ExpressSelect, {
                        id: _unref(model).intShipConfigId,
                        "onUpdate:id": _cache[12] || (_cache[12] = ($event: any) => ((_unref(model).intShipConfigId) = $event)),
                        defaultExpress: expresses.value,
                        getData: getData,
                        countryCode: _unref(sourceCountryRef),
                        "fee-tip": _unref(t)('请选择商品'),
                        disabled: __props.isChoice
                      }, null, 8, ["id", "defaultExpress", "countryCode", "fee-tip", "disabled"])
                    ]),
                    _createElementVNode("span", {
                      style: _normalizeStyle([{"font-size":"12px","margin-left":"10px","width":"210px","top":"36px","left":"-8px","line-height":"18px"}, _unref(isEN)() ? 'left:-8px;word-break: break-word;' : '']),
                      class: "abs ware flex-ter"
                    }, [
                      _createVNode(_component_el_icon, { style: {"font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(HomeFilled))
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)('店铺仓库所在地')) + "： ", 1),
                      (_unref(sourceCountryRef) === _unref(COUNTRY).KR)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(wareInfo.value?.warehouseNameTranslate), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_component_el_dropdown, { key: 1 }, {
                            dropdown: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_el_dropdown_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (selectedWareInfo.value = wareInfo.value))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_14, [
                                          _hoisted_15,
                                          _createTextVNode(" " + _toDisplayString(wareInfo.value?.warehouseNameTranslate), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (selectedWareInfo.value = _unref(jpWareInfo)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_16, [
                                          _hoisted_17,
                                          _createTextVNode(" " + _toDisplayString(_unref(jpWareInfo)?.warehouseNameTranslate), 1)
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_11, [
                                _createElementVNode("img", {
                                  style: {"width":"21px","margin-right":"4px"},
                                  src: `https://static-s.theckb.com/BusinessMarket/icon/icon_${selectedWareInfo.value.warehouseCountry}.png`,
                                  alt: "",
                                  srcset: ""
                                }, null, 8, _hoisted_12),
                                _createElementVNode("span", null, _toDisplayString(selectedWareInfo.value?.warehouseNameTranslate), 1),
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ArrowDownBold))
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }))
                    ], 4),
                    (_unref(sourceCountryRef) === _unref(COUNTRY).CN)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["free-a", _unref(useSite)()]),
                            target: "_blank",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (jumpExpressPrice()))
                          }, _toDisplayString(_unref(t)('运费估算')) + ">", 3)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["style"]),
              (_unref(isKO)() && countryCode.value === 'KR')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    prop: "clearanceCode",
                    label: _unref(t)('个人通关码'),
                    "label-width": 100,
                    style: {"transform":"translateX(-10px)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "texta",
                        class: "receive-address",
                        modelValue: _unref(model).clearanceCode,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(model).clearanceCode) = $event)),
                        maxlength: 100
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                style: {"width":"100%","overflow":"auto","margin-top":"16px","border-radius":"4px"},
                class: "flex-ter express-addition-label"
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('编辑国际物流附加项')), 1),
                    (_unref(isJA)())
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          effect: "light",
                          placement: "top",
                          "popper-class": "tool-tip-no-border"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('此设置只针对代采商品生效')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(QuestionMark, {
                              size: 14,
                              color: "#333",
                              class: "cursor-pt",
                              style: {"vertical-align":"text-top","margin-top":"4px","margin-left":"4px"}
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model).deliveryAdditionalList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "express-addition-item",
                        key: index
                      }, [
                        _createVNode(_component_el_tooltip, {
                          effect: "light",
                          placement: "top"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(item.additionNameJp), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(item.additionNameJp), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128)),
                    _createElementVNode("div", {
                      class: "express-addition-edit",
                      onClick: edit,
                      style: _normalizeStyle({ cursor: __props.isChoice ? 'no-drop' : 'pointer' })
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)('编辑')), 1)
                      ])
                    ], 4)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class", "model", "rules"]),
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              (showAdt.value)
                ? (_openBlock(), _createBlock(AdditionDrawer, {
                    key: 0,
                    cfg: _unref(model).deliveryAdditionalList,
                    "onUpdate:cfg": _cache[17] || (_cache[17] = ($event: any) => ((_unref(model).deliveryAdditionalList) = $event)),
                    onClose: _cache[18] || (_cache[18] = ($event: any) => (showAdt.value = false)),
                    reback: "",
                    type: "DeliAdt",
                    title: _unref(t)('编辑国际物流附加项'),
                    countryCode: _unref(sourceCountryRef)
                  }, null, 8, ["cfg", "title", "countryCode"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })),
          (_unref(isTikTokShop2C) && __props.mode === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('【重要】直发订单仅支持有库存的商品，我们不处理无{X}库存状态下的直发订单，因此务必先完成商品囤货之后，再进行直发。', {
            X: selectedWareInfo.value.warehouseCode === _unref(jpWareInfo).warehouseCode ? '日本' : "中国"
          })), 1)
                ]),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "light",
                  placement: "bottom-end"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _hoisted_36,
                        _createTextVNode(" そのため、人気商品や販売予定の商品は、事前にTHE CKB" + _toDisplayString(_unref(t)(selectedWareInfo.value.warehouseCode === _unref(jpWareInfo).warehouseCode
                  ? '日本仓' : '中国仓')) + "へ納品いただくことを推奨します。", 1),
                        _hoisted_37,
                        _hoisted_38,
                        _hoisted_39,
                        _hoisted_40,
                        _hoisted_41
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})